import React, { useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';


const PrivacyPolicy = () => {
  const topRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleKnowMore = () => {
    navigate('/', { state: { scrollToEmail: true } });
  };

  return (
    <div
      className="min-h-screen paper-texture bg-fixed bg-primary-beige"
    >
      {/* Texture overlay removed globally */}

      {/* Shared Header Component */}
      <Header onInnerCircleClick={handleKnowMore} />

      {/* Scroll target */}
      <div ref={topRef} />

      {/* Content - Added top padding for fixed header */}
      <main className="relative z-10 pt-24 md:pt-28 pb-16 md:pb-24">
        {/* Full width title section */}
        <div className="w-full mb-12 flex flex-col items-center">
          <div className="w-full flex items-center justify-between gap-4 sm:gap-6">
            <div className="h-px bg-primary-sky-blue flex-grow" />
            <h1
              className="font-heading text-3xl md:text-5xl text-center px-4 shrink-0 text-primary-royal-blue"
            >
              Privacy Policy
            </h1>
            <div className="h-px bg-primary-sky-blue flex-grow" />
          </div>
          <p className="mt-4 font-body text-sm text-primary-royal-blue/70">
            Last Updated: February 2026
          </p>
        </div>

        {/* Content Container */}
        <div className="max-w-3xl mx-auto px-6 py-8 md:px-12 md:py-12 space-y-8 bg-gradient-to-b from-white to-[#f5f5f5] shadow-2xl rounded-sm relative">

          {/* Golden top border accent */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-gradient-gold-start to-brand-gradient-gold-end" />
          <section>
            <h2 className="font-heading text-xl mb-4 text-primary-royal-blue">
              1. Introduction
            </h2>
            <p className="font-body text-sm md:text-base leading-relaxed text-primary-royal-blue">
              ZURIAN INTERNATIONAL PRIVATE LIMITED ("ZURIAN," "we," "our," or "us") respects your privacy and is committed to protecting your personal data. This Privacy Policy outlines our practices regarding the collection, use, and disclosure of your information when you interact with our website and join our Early Access Program.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl mb-4 text-primary-royal-blue">
              2. Information We Collect
            </h2>
            <p className="font-body text-sm md:text-base leading-relaxed mb-4 text-primary-royal-blue">
              We collect information to provide you with a superior experience and deliver our services:
            </p>
            <ul className="font-body text-sm md:text-base leading-relaxed space-y-2 ml-6 text-primary-royal-blue">
              <li>• <strong>Contact Information:</strong> Email address and optional Instagram ID provided during registration.</li>
              <li>• <strong>Usage Data:</strong> Information on how you access and use our website.</li>
              <li>• <strong>Communication Data:</strong> Records of your interactions with us, including responses to our newsletters or surveys.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl mb-4 text-primary-royal-blue">
              3. How We Use Your Information
            </h2>
            <p className="font-body text-sm md:text-base leading-relaxed mb-4 text-primary-royal-blue">
              We use your personal data for the following specific purposes:
            </p>
            <ul className="font-body text-sm md:text-base leading-relaxed space-y-2 ml-6 text-primary-royal-blue">
              <li>• <strong>Early Access Benefits:</strong> To send you exclusive coupon codes, launch notifications, and invitations to our private community channels.</li>
              <li>• <strong>Communication:</strong> To manage our relationship with you, including sending newsletters and responding to your inquiries.</li>
              <li>• <strong>Improvement:</strong> To analyze usage trends and improve our website functionality and user experience.</li>
              <li>• <strong>Security:</strong> To detect, prevent, and address technical issues or fraudulent activities.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl mb-4 text-primary-royal-blue">
              4. Data Sharing & Disclosure
            </h2>
            <p className="font-body text-sm md:text-base leading-relaxed text-primary-royal-blue">
              We do not sell your personal data. We may share your information with trusted third-party service providers who assist us in operating our website and conducting our business (e.g., email marketing platforms, analytics providers), subject to confidentiality agreements and strictly for the purposes outlined in this policy.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl mb-4 text-primary-royal-blue">
              5. Your Data Rights
            </h2>
            <p className="font-body text-sm md:text-base leading-relaxed text-primary-royal-blue">
              You have the right to access, correct, or request deletion of your personal data. You may opt out of receiving marketing communications at any time by following the unsubscribe link in our emails or by contacting us directly.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl mb-4 text-primary-royal-blue">
              6. Security
            </h2>
            <p className="font-body text-sm md:text-base leading-relaxed text-primary-royal-blue">
              We employ industry-standard security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is completely secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl mb-4 text-primary-royal-blue">
              7. Contact Us
            </h2>
            <p className="font-body text-sm md:text-base leading-relaxed text-primary-royal-blue">
              If you have any questions about this Privacy Policy, please contact us at:
              <br /><br />
              <strong>Email:</strong> <a href="mailto:care@zurian.co.in" className="hover:underline">care@zurian.co.in</a>
              <br />
              <strong>Company:</strong> ZURIAN INTERNATIONAL PRIVATE LIMITED
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
